module.exports = __webpack_public_path__ + "img/Phone.0538b4ad.png";